//css
import './App.css';
import './assets/css/fontawesome/css/all.css';
import './assets/css/bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/soft-ui-dashboard.css';
import './assets/css/fotopaciente.css';
import './assets/css/estilo.css';

//js
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

//react
import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';

// context
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { UserAPIProvider } from './contexts/UserAPIContext';
import { PaginationProvider } from './contexts/PaginationContext';

import AppRoutes from './routes/AppRoutes';

// Wrapper component to access location
const AppContent = () => {
  const location = useLocation();
  
  return (
    <PaginationProvider pathname={location.pathname}>
      <AppRoutes />
    </PaginationProvider>
  );
};

function App() {
  return (
    <div>
      <AuthProvider>
        <UserAPIProvider>
          <NotificationProvider>
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </NotificationProvider>
        </UserAPIProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
